<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" linear #stepper>

  <!-- Step 1: Osnovni podaci o ugovoru -->
  <mat-step [stepControl]="contractForm">
    <ng-template matStepLabel>I. Osnovni podaci o ugovoru</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">I. Osnovni podaci o ugovoru</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="contractForm">
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Klasa</mat-label>
              <input matInput formControlName="classification" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Urudžbeni broj</mat-label>
              <input matInput formControlName="refNumber" />
            </mat-form-field>
          </div>
          @if (projectType === ProjectType.Application) {
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Broj ugovora</mat-label>
                <input matInput formControlName="number" />
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Račun (konto)</mat-label>
                <input matInput formControlName="account" />
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Aktivnost</mat-label>
                <input matInput formControlName="activity" />
              </mat-form-field>
            </div>
          }
          @if (projectType === ProjectType.Allocation) {
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Klasa Odluke općinskog načelnika</mat-label>
                <input matInput formControlName="decisionClassificationCode">
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Urudžbeni broj Odluke općinskog načelnika</mat-label>
                <input matInput formControlName="decisionReferenceNumber">
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Datum Odluke općinskog načelnika</mat-label>
                <input matInput [matDatepicker]="decisionPicker" formControlName="decisionDate">
                <mat-datepicker-toggle matSuffix [for]="decisionPicker"></mat-datepicker-toggle>
                <mat-datepicker #decisionPicker></mat-datepicker>
              </mat-form-field>
            </div>
          }
          <mat-form-field class="mb-25">
            <mat-label>Datum ugovora:</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <button mat-flat-button matStepperNext color="primary" [disabled]="contractForm.invalid">
            Dalje
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2: Potvrda -->
  <mat-step>
    <ng-template matStepLabel>Potvrda</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">
            {{ isUpdating ? 'Ažuriranje' : 'Kreiranje' }} ugovora
          </h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div>
          <button mat-flat-button matStepperPrevious class="mr-15">
            Nazad
          </button>
          <button mat-flat-button color="primary" (click)="onSubmit()">
            Spremi
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-step>
</mat-stepper>
